
<div>

    <div [style.display]="vm.showDatatable ? 'block': 'none'">

        <div class="mb-4">

            <mat-toolbar [attr.test-id]="'projects-toolbar'">
                <mat-toolbar-row class="mce-datatable-toolbar-row">
                    <button matButton="elevated" (click)="addProject()" [disabled]="vm.projectCreationDisabled">
                        <mat-icon>add</mat-icon>Add Project
                    </button>
                </mat-toolbar-row>
            </mat-toolbar>

        </div>

        @if (vm.freePlanLimitReached || vm.freePlanLimitExceeded)
        {
        <div class="mb-4">
            <mce-info-message type="warning">
                Free Plan users can only have one project. To create more projects, please <a routerLink="/account" class="underline">upgrade to Pro</a>.
                @if (vm.freePlanLimitExceeded) {
                <p class="mt-2">
                    Editing projects, accessing project cables, and managing users are disabled until you delete projects so that only one remains. Upgrade to Pro to remove all Free Plan limits.
                </p>
                }
            </mce-info-message>
        </div>
        }

        @if (vm.firstProjectIsFree && !isSharedBillingMember()) {
        <div class="mb-4">
            <mce-info-message type="information">
                Your first project is free—no credits will be charged. Your 30 Free Plan credits remain available for cables and reports.
            </mce-info-message>
        </div>
        }

        @if (!vm.disableGettingStartedMsg) {
        <div class="mb-4">
            <mce-info-message type="information">
                <p><b>Getting Started</b></p>
                <ol class="list-inside list-decimal">
                    <li>Add a project [use '+ Project' ].</li>
                    <li>Navigate to your project's cables [use <mat-icon class="align-middle !text-lg">group_work</mat-icon>or<mat-icon class="align-middle !text-lg">more_vert</mat-icon>].</li>
                    <li>Add one or two cables and print a Cable Sizing Report [use '+ Cable' then 'Reports' ].</li>
                </ol>
            </mce-info-message>
        </div>
        }



        <mce-data-table [displayedColumns]="vm.dataTable.displayedColumns"
                        [data]="vm.dataTable.data"
                        [headers]="vm.dataTable.headers"
                        [cellTemplates]="vm.dataTable.templates">

            <ng-template #logo let-row="row">
                <div class="max-h-32 max-w-32 p-1">
                    <img src='{{row.logoUrl.value}}' />
                </div>
            </ng-template>

            <ng-template #rowActions let-row="row">

                <button mat-icon-button (click)="onEditProject(row)" [disabled]="vm.freePlanLimitExceeded"
                        [attr.test-id]="'button-project-edit'">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onGoCables(row)" [disabled]="vm.freePlanLimitExceeded">
                    <mat-icon>group_work</mat-icon>
                </button>

                <button mat-icon-button [matMenuTriggerFor]="moreActions">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #moreActions>

                    <button mat-menu-item (click)="onEditProject(row)" [disabled]="vm.freePlanLimitExceeded">
                        <mat-icon>edit</mat-icon>Edit Project
                    </button>
                    <button mat-menu-item (click)="onGoCables(row)" [disabled]="vm.freePlanLimitExceeded">
                        <mat-icon>group_work</mat-icon>Go to project cables
                    </button>
                    <button mat-menu-item (click)="onUsers(row)" [disabled]="vm.freePlanLimitExceeded">
                        <mat-icon>people</mat-icon>Manage Users
                    </button>
                    <button mat-menu-item (click)="onCopyProject(row)" [disabled]="vm.projectCreationDisabled">
                        <mat-icon>content_copy</mat-icon>Copy Project
                    </button>
                    <button mat-menu-item (click)="onDeleteProject(row)">
                        <mat-icon>delete</mat-icon>Delete
                    </button>

                    <button mat-menu-item
                            matTooltip="Issues with the project, please open a ticket quoting reference {{row.uid}}. Click to copy reference to clipboard."
                            [cdkCopyToClipboard]="row.uid">
                        <mat-icon>chat_info</mat-icon>Reference
                    </button>

                </mat-menu>

            </ng-template>

        </mce-data-table>

    </div>

        @if (vm.showLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }


    </div>

@if (vm.showSpinner) {
<div class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
}

@if (vm.showEditForm) {
<project-edit [project]="vm.editProject"
              [comments]="vm.editComments"
              [showDebugPanel]="vm.showDebugPanel"
              (cancelClick)="onCancel()"
              (saveClick)="onEditSave($event)"></project-edit>
}

@if (vm.showUsersForm) {
<project-users [project]="vm.editProject" (cancelClick)="onCancel()"></project-users>
}
